import { render, staticRenderFns } from "./system-code.vue?vue&type=template&id=e126eb8c&scoped=true"
import script from "./system-code.vue?vue&type=script&lang=js"
export * from "./system-code.vue?vue&type=script&lang=js"
import style0 from "./system-code.vue?vue&type=style&index=0&id=e126eb8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e126eb8c",
  null
  
)

export default component.exports